import { BanquetHall, BanquetBooking, BanquetOrder } from '../types';

// Mock Banquet Halls Data
export const mockBanquetHalls: BanquetHall[] = [
  {
    hallId: 'HALL-001',
    hallName: 'Grand Ballroom',
    capacity: 200,
    hallType: 'Premium',
    location: 'Ground Floor',
    amenities: ['Air Conditioning', 'Sound System', 'Projector', 'Stage', 'Dance Floor', 'Bar Counter'],
    hourlyRate: 5000,
    status: 'available',
  },
  {
    hallId: 'HALL-002',
    hallName: 'Royal Hall',
    capacity: 150,
    hallType: 'Deluxe',
    location: 'First Floor',
    amenities: ['Air Conditioning', 'Sound System', 'Projector', 'Stage', 'Dance Floor'],
    hourlyRate: 4000,
    status: 'available',
  },
  {
    hallId: 'HALL-003',
    hallName: 'Garden Pavilion',
    capacity: 100,
    hallType: 'Standard',
    location: 'Garden Area',
    amenities: ['Natural Lighting', 'Garden View', 'Sound System', 'Outdoor Seating'],
    hourlyRate: 3000,
    status: 'available',
  },
  {
    hallId: 'HALL-004',
    hallName: 'Conference Room A',
    capacity: 50,
    hallType: 'Conference',
    location: 'Second Floor',
    amenities: ['Air Conditioning', 'Projector', 'Whiteboard', 'Video Conferencing'],
    hourlyRate: 2000,
    status: 'available',
  },
  {
    hallId: 'HALL-005',
    hallName: 'Crystal Hall',
    capacity: 120,
    hallType: 'Elegant',
    location: 'Ground Floor',
    amenities: ['Chandeliers', 'Air Conditioning', 'Sound System', 'Dance Floor', 'Bar Counter'],
    hourlyRate: 4500,
    status: 'maintenance',
  },
  {
    hallId: 'HALL-006',
    hallName: 'Sky Lounge',
    capacity: 80,
    hallType: 'Rooftop',
    location: 'Rooftop',
    amenities: ['City View', 'Air Conditioning', 'Sound System', 'Outdoor Seating', 'Bar Counter'],
    hourlyRate: 3500,
    status: 'available',
  },
];

// Mock Banquet Bookings Data - Spread from Nov 1-10, 2025
export const mockBanquetBookings: BanquetBooking[] = [
  {
    bookingId: 1001,
    hallId: 'HALL-001',
    guestId: 2001,
    guestName: 'Rajesh Kumar',
    phone: '+91 98765 43210',
    email: 'rajesh.kumar@email.com',
    eventName: 'Wedding Reception',
    eventType: 'wedding',
    bookingDate: '2025-10-15',
    eventDate: '2025-11-01',
    startTime: '18:00',
    endTime: '23:00',
    duration: 5,
    guestCount: 150,
    totalAmount: 25000,
    advanceAmount: 10000,
    balanceAmount: 15000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Vegetarian menu only, DJ required, flower decoration',
    cateringRequired: true,
    decorationRequired: true,
    audioVisualRequired: true,
    bookingSource: 'direct',
    createdBy: 'admin',
    lastModified: '2025-10-15T10:30:00Z',
  },
  {
    bookingId: 1002,
    hallId: 'HALL-002',
    guestId: 2002,
    guestName: 'Priya Sharma',
    phone: '+91 87654 32109',
    email: 'priya.sharma@company.com',
    eventName: 'Corporate Annual Meet',
    eventType: 'corporate',
    bookingDate: '2025-10-20',
    eventDate: '2025-11-02',
    startTime: '09:00',
    endTime: '17:00',
    duration: 8,
    guestCount: 120,
    totalAmount: 32000,
    advanceAmount: 16000,
    balanceAmount: 16000,
    bookingStatus: 'confirmed',
    specialRequirements: 'High-speed internet, presentation setup, lunch buffet',
    cateringRequired: true,
    decorationRequired: false,
    audioVisualRequired: true,
    bookingSource: 'website',
    createdBy: 'admin',
    lastModified: '2025-10-20T14:15:00Z',
  },
  {
    bookingId: 1003,
    hallId: 'HALL-003',
    guestId: 2003,
    guestName: 'Amit Singh',
    phone: '+91 76543 21098',
    email: 'amit.singh@email.com',
    eventName: 'Birthday Celebration',
    eventType: 'birthday',
    bookingDate: '2025-10-25',
    eventDate: '2025-11-03',
    startTime: '19:00',
    endTime: '24:00',
    duration: 5,
    guestCount: 80,
    totalAmount: 15000,
    advanceAmount: 5000,
    balanceAmount: 10000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Birthday cake, party decorations, music system',
    cateringRequired: true,
    decorationRequired: true,
    audioVisualRequired: false,
    bookingSource: 'phone',
    createdBy: 'admin',
    lastModified: '2025-10-25T16:45:00Z',
  },
  {
    bookingId: 1004,
    hallId: 'HALL-004',
    guestId: 2004,
    guestName: 'Dr. Neha Patel',
    phone: '+91 65432 10987',
    email: 'neha.patel@hospital.com',
    eventName: 'Medical Conference 2025',
    eventType: 'conference',
    bookingDate: '2025-10-30',
    eventDate: '2025-11-04',
    startTime: '08:00',
    endTime: '18:00',
    duration: 10,
    guestCount: 45,
    totalAmount: 20000,
    advanceAmount: 10000,
    balanceAmount: 10000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Medical equipment display, coffee breaks, lunch',
    cateringRequired: true,
    decorationRequired: false,
    audioVisualRequired: true,
    bookingSource: 'direct',
    createdBy: 'admin',
    lastModified: '2025-10-30T11:20:00Z',
  },
  {
    bookingId: 1005,
    hallId: 'HALL-001',
    guestId: 2005,
    guestName: 'Sunita Gupta',
    phone: '+91 54321 09876',
    email: 'sunita.gupta@email.com',
    eventName: 'Anniversary Celebration',
    eventType: 'other',
    bookingDate: '2025-11-01',
    eventDate: '2025-11-05',
    startTime: '18:30',
    endTime: '22:30',
    duration: 4,
    guestCount: 60,
    totalAmount: 20000,
    advanceAmount: 8000,
    balanceAmount: 12000,
    bookingStatus: 'pending',
    specialRequirements: 'Romantic decoration, candlelight dinner setup',
    cateringRequired: true,
    decorationRequired: true,
    audioVisualRequired: false,
    bookingSource: 'walk-in',
    createdBy: 'admin',
    lastModified: '2025-11-01T09:10:00Z',
  },
  {
    bookingId: 1006,
    hallId: 'HALL-006',
    guestId: 2006,
    guestName: 'Vikram Reddy',
    phone: '+91 43210 98765',
    email: 'vikram.reddy@tech.com',
    eventName: 'Tech Startup Launch',
    eventType: 'corporate',
    bookingDate: '2025-11-02',
    eventDate: '2025-11-06',
    startTime: '16:00',
    endTime: '21:00',
    duration: 5,
    guestCount: 70,
    totalAmount: 17500,
    advanceAmount: 8750,
    balanceAmount: 8750,
    bookingStatus: 'completed',
    specialRequirements: 'Tech demo setup, networking area, finger food',
    cateringRequired: true,
    decorationRequired: false,
    audioVisualRequired: true,
    bookingSource: 'referral',
    createdBy: 'admin',
    lastModified: '2025-11-02T13:30:00Z',
  },
  {
    bookingId: 1007,
    hallId: 'HALL-002',
    guestId: 2007,
    guestName: 'Ravi Verma',
    phone: '+91 32109 87654',
    email: 'ravi.verma@email.com',
    eventName: 'Diwali Celebration',
    eventType: 'other',
    bookingDate: '2025-11-03',
    eventDate: '2025-11-07',
    startTime: '17:00',
    endTime: '22:00',
    duration: 5,
    guestCount: 100,
    totalAmount: 18000,
    advanceAmount: 9000,
    balanceAmount: 9000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Traditional decorations, diya lighting, rangoli',
    cateringRequired: true,
    decorationRequired: true,
    audioVisualRequired: false,
    bookingSource: 'direct',
    createdBy: 'admin',
    lastModified: '2025-11-03T10:15:00Z',
  },
  {
    bookingId: 1008,
    hallId: 'HALL-003',
    guestId: 2008,
    guestName: 'Kavya Reddy',
    phone: '+91 21098 76543',
    email: 'kavya.reddy@email.com',
    eventName: 'Engagement Ceremony',
    eventType: 'wedding',
    bookingDate: '2025-11-04',
    eventDate: '2025-11-08',
    startTime: '16:00',
    endTime: '21:00',
    duration: 5,
    guestCount: 90,
    totalAmount: 22000,
    advanceAmount: 11000,
    balanceAmount: 11000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Traditional setup, flower garlands, photographer',
    cateringRequired: true,
    decorationRequired: true,
    audioVisualRequired: true,
    bookingSource: 'website',
    createdBy: 'admin',
    lastModified: '2025-11-04T14:20:00Z',
  },
  {
    bookingId: 1009,
    hallId: 'HALL-004',
    guestId: 2009,
    guestName: 'Manoj Tiwari',
    phone: '+91 10987 65432',
    email: 'manoj.tiwari@company.com',
    eventName: 'Product Launch Event',
    eventType: 'corporate',
    bookingDate: '2025-11-05',
    eventDate: '2025-11-09',
    startTime: '10:00',
    endTime: '16:00',
    duration: 6,
    guestCount: 40,
    totalAmount: 12000,
    advanceAmount: 6000,
    balanceAmount: 6000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Product display area, media setup, press conference',
    cateringRequired: true,
    decorationRequired: false,
    audioVisualRequired: true,
    bookingSource: 'phone',
    createdBy: 'admin',
    lastModified: '2025-11-05T11:30:00Z',
  },
  {
    bookingId: 1010,
    hallId: 'HALL-006',
    guestId: 2010,
    guestName: 'Meera Joshi',
    phone: '+91 09876 54321',
    email: 'meera.joshi@email.com',
    eventName: 'Farewell Party',
    eventType: 'other',
    bookingDate: '2025-11-06',
    eventDate: '2025-11-10',
    startTime: '18:30',
    endTime: '23:30',
    duration: 5,
    guestCount: 65,
    totalAmount: 16000,
    advanceAmount: 8000,
    balanceAmount: 8000,
    bookingStatus: 'confirmed',
    specialRequirements: 'Farewell decorations, photo booth, music system',
    cateringRequired: true,
    decorationRequired: true,
    audioVisualRequired: true,
    bookingSource: 'walk-in',
    createdBy: 'admin',
    lastModified: '2025-11-06T15:45:00Z',
  },
];

// Mock Banquet Orders Data - Updated for Nov 1-10, 2025
export const mockBanquetOrders: BanquetOrder[] = [
  {
    orderId: 3001,
    bookingId: 1001,
    itemName: 'Wedding Catering Package',
    orderTime: '2025-11-01T18:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '15000',
    unitPrice: '15000',
    category: 'catering',
  },
  {
    orderId: 3002,
    bookingId: 1001,
    itemName: 'Flower Decoration',
    orderTime: '2025-11-01T16:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '5000',
    unitPrice: '5000',
    category: 'decoration',
  },
  {
    orderId: 3003,
    bookingId: 1001,
    itemName: 'DJ Services',
    orderTime: '2025-11-01T18:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '3000',
    unitPrice: '3000',
    category: 'audiovisual',
  },
  {
    orderId: 3004,
    bookingId: 1002,
    itemName: 'Conference Lunch Buffet',
    orderTime: '2025-11-02T12:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '8000',
    unitPrice: '8000',
    category: 'catering',
  },
  {
    orderId: 3005,
    bookingId: 1002,
    itemName: 'Projector Rental',
    orderTime: '2025-11-02T08:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '2000',
    unitPrice: '2000',
    category: 'audiovisual',
  },
  {
    orderId: 3006,
    bookingId: 1003,
    itemName: 'Birthday Party Package',
    orderTime: '2025-11-03T19:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '8000',
    unitPrice: '8000',
    category: 'catering',
  },
  {
    orderId: 3007,
    bookingId: 1003,
    itemName: 'Party Decorations',
    orderTime: '2025-11-03T18:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '2000',
    unitPrice: '2000',
    category: 'decoration',
  },
  {
    orderId: 3008,
    bookingId: 1004,
    itemName: 'Conference Coffee Breaks',
    orderTime: '2025-11-04T10:00:00Z',
    quantity: 2,
    status: 'delivered',
    totalAmount: '3000',
    unitPrice: '1500',
    category: 'catering',
  },
  {
    orderId: 3009,
    bookingId: 1004,
    itemName: 'Audio System Setup',
    orderTime: '2025-11-04T07:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '1500',
    unitPrice: '1500',
    category: 'audiovisual',
  },
  {
    orderId: 3010,
    bookingId: 1006,
    itemName: 'Networking Finger Food',
    orderTime: '2025-11-06T16:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '5000',
    unitPrice: '5000',
    category: 'catering',
  },
  {
    orderId: 3011,
    bookingId: 1007,
    itemName: 'Diwali Special Menu',
    orderTime: '2025-11-07T17:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '10000',
    unitPrice: '10000',
    category: 'catering',
  },
  {
    orderId: 3012,
    bookingId: 1007,
    itemName: 'Traditional Diwali Decorations',
    orderTime: '2025-11-07T15:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '3000',
    unitPrice: '3000',
    category: 'decoration',
  },
  {
    orderId: 3013,
    bookingId: 1008,
    itemName: 'Engagement Catering',
    orderTime: '2025-11-08T16:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '12000',
    unitPrice: '12000',
    category: 'catering',
  },
  {
    orderId: 3014,
    bookingId: 1008,
    itemName: 'Flower Garlands & Decorations',
    orderTime: '2025-11-08T14:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '4000',
    unitPrice: '4000',
    category: 'decoration',
  },
  {
    orderId: 3015,
    bookingId: 1009,
    itemName: 'Product Launch Catering',
    orderTime: '2025-11-09T10:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '6000',
    unitPrice: '6000',
    category: 'catering',
  },
  {
    orderId: 3016,
    bookingId: 1009,
    itemName: 'Media Setup & AV Equipment',
    orderTime: '2025-11-09T08:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '2000',
    unitPrice: '2000',
    category: 'audiovisual',
  },
  {
    orderId: 3017,
    bookingId: 1010,
    itemName: 'Farewell Party Buffet',
    orderTime: '2025-11-10T18:30:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '8000',
    unitPrice: '8000',
    category: 'catering',
  },
  {
    orderId: 3018,
    bookingId: 1010,
    itemName: 'Photo Booth Setup',
    orderTime: '2025-11-10T17:00:00Z',
    quantity: 1,
    status: 'delivered',
    totalAmount: '3000',
    unitPrice: '3000',
    category: 'audiovisual',
  },
];

// Helper function to get bookings for a specific hall
export const getBookingsForHall = (hallId: string): BanquetBooking[] => {
  return mockBanquetBookings.filter(booking => booking.hallId === hallId);
};

// Helper function to get orders for a specific booking
export const getOrdersForBooking = (bookingId: number): BanquetOrder[] => {
  return mockBanquetOrders.filter(order => order.bookingId === bookingId);
};

// Helper function to get halls with booking information
export const getHallsWithBookings = (): BanquetHall[] => {
  return mockBanquetHalls.map(hall => {
    const hallBooking = mockBanquetBookings.find(
      booking => booking.hallId === hall.hallId && 
                (booking.bookingStatus === 'confirmed' || booking.bookingStatus === 'completed')
    );
    
    if (hallBooking) {
      return {
        ...hall,
        guestName: hallBooking.guestName,
        bookingStatus: hallBooking.bookingStatus,
        eventStartDate: hallBooking.eventDate,
        eventEndDate: hallBooking.eventDate,
        eventType: hallBooking.eventType,
        status: 'occupied' as const,
      };
    }
    
    return hall;
  });
};
